<div class="modal-header">
  <h5 class="modal-title">{{'Export' | messageTranslate}}</h5>
  <button type="button" class="btn-close" [attr.aria-label]="'Close' | messageTranslate" (click)="modal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
  <div class="card">
    <div class="card-body">
      <p>{{message | messageTranslate}}</p>
      <app-button visual="primary"
                  label="Generate"
                  [ngbTooltip]="generateDisabledReason | messageTranslate"
                  [disableTooltip]="!generateDisabledReason"
                  [disabled]="generateDisabledReason || isExportLoading || isExportReady"
                  [loading]="isExportLoading"
                  (buttonClick)="triggerGenerate()"/>
      @let progressDecimal = this.progressDecimal;
      @if (isExportLoading) {
        <ngb-progressbar class="my-3"
                         type="success"
                         [value]="progressDecimal * 100"
                         [striped]="progressDecimal >= 1">
          @if (loadingMessage) {
            {{loadingMessage | messageTranslate}}
          } @else {
            {{(progressDecimal > 1 ? 1 : progressDecimal) | percent: '1.1'}}
          }
        </ngb-progressbar>
      }
      @if (isExportReady) {
        <div class="alert alert-secondary p-2 mt-3 mb-0">
          <button type="button" class="btn btn-link link-dark" (click)="triggerDownload()">
            <div class="d-flex align-items-center gap-2">
              <app-icon size="sm" display="flex" name="download"/>
              <span>{{'Download' | messageTranslate}}</span>
            </div>
          </button>
        </div>
      }
    </div>
  </div>
</div>
<div class="modal-footer align-items-end">
  <app-button visual="secondary" label="Close" (buttonClick)="modal.dismiss('Cross click')"/>
</div>